import { Text } from '@adc/parallax-component-library';

import { useModal } from '~/features/modals/useModal';

import { Modal } from '../Modal';

type DepartmentCreateModalProps = {
  testID: string;
};

export const DepartmentCreateModal = ({
  testID,
}: DepartmentCreateModalProps) => {
  const { closeModal } = useModal();

  return (
    <Modal
      title="Add Department"
      testID={testID}
      hasCloseButton
      size="l"
      primaryAction={{
        label: 'Done',
        onPress: () => {
          closeModal('DepartmentCreate');
        },
      }}
      onOpenChange={() => {
        closeModal('DepartmentCreate');
      }}
    >
      <Text type="$bodyBase.default">To be implemented</Text>
    </Modal>
  );
};
